export const rioTintoStaticData = [
  {
    cardNumber: 1,
    cardHeadingNumber: 5,
    title: 'Your Novated Lease Checklist',
    prefix:
      '<p>This checklist contains information and facts in relation to your Novated Lease proposal. It has been prepared to assist you in understanding your obligations under the proposed lease.</p><p>Please acknowledge that you have read and accept the points below by checking the tick boxes in consultation with a Maxxia representative.</p>',
    prefixPdf:
      'This checklist contains information and facts in relation to your Novated Lease proposal. It has been prepared to assist you in understanding your obligations under the proposed lease.',
    pdfText:
      'You have already accepted this checklist, at the proposal stage in consultation with a Maxxia representative.',
    datablocks: [
      {
        heading: 'Part 1. Proposal Details',
        showIds: true,
        checklistItems: [
          {
            id: 1.1,
            isChecked: false,
            text: 'I understand that the budgeted cost per month in my <i>Proposal</i> includes a mixture of expenses that are fixed for the term of lease and expense that are estimated as follows:<ul><li>Fixed Expenses: Lease Rentals (inclusive of the customer interest rate of |interestRate|%), Management Fee.</li><li>Estimated Expenses: Registration, Maintenance, Tyres, Fuel, Comprehensive Insurance, Incidentals and Roadside Assistance.</li></ul>',
          },
          {
            id: 1.2,
            isChecked: false,
            text: 'I understand that the budgeted cost per month in my <i>Proposal</i> does not include road and bridge tolls, parking fees, parking fines, and speeding fines. These costs cannot be salary packaged.',
          },
          {
            id: 1.3,
            isChecked: false,
            text: 'I understand that the actual cost of the operating expenses may vary from my budget if there is a change in my vehicle usage or change in statutory charges. Any such change could result in the need to alter the amount of my salary packacking contributions. I agree to make any necessary change within four weeks of notification to Maxxia.',
          },
          {
            id: 1.4,
            isChecked: false,
            text: 'I understand that if elected, the proposed monthly lease rental in my proposal could include a provision for insurance to provide protection in the event of my death or involuntary redundancy during the term of my lease. A document explaining the benefits available under the policy has been provided to me by Maxxia.',
          },
          {
            id: 1.5,
            isChecked: false,
            text: 'I will be responsible for all maintenance and running costs (including registration, third party insurance premiums, repairs, fuel and oil).<br /><br />I acknowledge that if I have a fully maintained lease Maxxia will only make payments to a third party if I submit an eligible claim at least 10 working days prior to the payment due date, and I will keep the vehicle in good condition and working order.',
          },
          {
            id: 1.6,
            isChecked: false,
            text: 'I will maintain comprehensive insurance over the vehicle of a type acceptable to the financier of the vehicle.',
          },
        ],
      },
      {
        heading: 'Part 2. Fringe Benefits Tax',
        showIds: true,
        checklistItems: [
          {
            id: 2.1,
            isChecked: false,
            text: 'Maxxia has explained to me that there are two methods of structuring my rental payment to meet my Fringe Benefits Tax (FBT) obligations:<ul><li>The payment of FBT from my pre tax salary; or</li><li>Making a post tax contribution to my employer, which is equal to the taxable value of the vehicle as calculated by the <i>Statutory Formula Method</i>.</li></ul>',
          },
          {
            id: 2.2,
            isChecked: false,
            text: 'I understand that the applicable Fringe Benefits Tax (FBT) for my motor vehicle lease will be calculated each FBT year (1 April to 31 March of the next calendar year) using the <i>Statutory Formula Method<i>.',
          },
          {
            id: 2.3,
            isChecked: false,
            text: 'As detailed in the Proposal provided to me by Maxxia, my salary packaging contributions will be a combination of before tax and post tax contributions (Employee Contribution Method).',
          },
          {
            id: 2.4,
            isChecked: false,
            text: 'The post tax contributions in my Proposal have been calculated on the basis that the taxable value of the vehicle will be nil in any FBT year. The Statutory Percentage used in this calculation is 20% which based on my estimate that the annualised kilometres travelled during each FBT year that the vehicle is leased by me is more than |annualKm| kilometres.',
          },
        ],
      },
      {
        heading: 'Part 3. Termination of Lease',
        showIds: true,
        checklistItems: [
          {
            id: 3.1,
            isChecked: false,
            text: 'At the end of the lease term I have an obligation to pay the residual value to the financier. I understand that I may sell or trade the vehicle at the end of lease and put the proceeds towards the residual value payment. If I sell the vehicle for less than the residual value owing I will make up the shortfall to the financier. Based on current tax rulings if I sell the vehicle for more than the residual value the profit can be retained by me without any tax implications.',
          },
          {
            id: 3.2,
            isChecked: false,
            text: 'If I cease employment with Rio Tinto prior to the lease end date, I understand that the obligation of Rio Tinto to make lease payments will cease immediately and I am responsible for any continuing payments to the financier. Alternatively, I may pay out the amount outstanding on the lease to the financier and retain the vehicle. I understand that I do not have the option of returning the vehicle to the financier. If I am a Fixed Term Employee, this will apply if my Fixed Term Contract is shorter than the lease term I choose.',
          },
          {
            id: 3.3,
            isChecked: false,
            text: 'I understand that I have the option of terminating the lease prior to the lease end date. Depending on the length of lease that has expired I understand that the payout figure due to the financier may be higher than the market value of the vehicle. I also understand that the financier may impose fees and charges for the early termination of the lease.',
          },
          {
            id: 3.4,
            isChecked: false,
            text: 'I understand that at the end of the lease term or in the event of early termination, any funds held by Maxxia will be returned to me after the deduction of relevant income tax by Rio Tinto. The final reconciliation of my actual expenditure for the vehicle will be completed 60 days after my lease is terminated. If I have a shortfall ie my expenses have exceeded my budget then I agree to pay the shortfall amount directly to Maxxia within sixty days of notification of the shortfall amount.',
          },
        ],
      },
      {
        heading: 'Part 4. Other',
        showIds: true,
        checklistItems: [
          {
            id: 4.1,
            isChecked: false,
            text: "I confirm that I have been provided with a <a style='color: #666; text-decoration: underline' href='/pdfs/Maxxia_MonthlyBudgetPlanner.pdf' download>Monthly Budget Planner</a> by Maxxia for me to complete. I also acknowledge that the  <a style='color: #666; text-decoration: underline' href='/pdfs/Maxxia_MonthlyBudgetPlanner.pdf' download>Monthly Budget Planner</a> is only as accurate as the information provided and does not constitute financial advice.",
          },
          {
            id: 4.2,
            isChecked: false,
            text: 'I acknowledge that Maxxia has explained to me that fringe benefits with a taxable value included in a salary package for the FBT year are reported on my payment summary for the financial year ending 30 June. The grossed-up value of fringe benefits will be included for most government surcharges and income tests including:<ul><li>Child support obligations</li><li>Higher Education Contribution Scheme (HECS) repayment</li><li>Medicare levy surcharge</li><li>Personal superannuation contributions Rebate</li><li>Rebate for Spouse Superannuation Contributions</li><li>Superannuation contributions surcharge</li></ul>',
          },
          {
            id: 4.3,
            isChecked: false,
            text: "I acknowledge and agree that Maxxia and its employees and contractors:<ol type='a'><li>may receive commissions, volume discounts, fees and other benefits in connection with the supply of salary packaging or vehicle management services; and</li><li>are not required to make specific disclosure to me of the amount of such receipts or the manner in which those receipts are calculated.</li></ol>",
          },
        ],
      },
    ],
  },
  {
    cardNumber: 2,
    cardHeadingNumber: 6,
    title: 'Your Employee Acknowledgement',
    prefix: '<p>I acknowledge that:</p>',
    pdfText:
      'You have already acknowledged the points before at the proposal stage.',
    datablocks: [
      {
        showIds: false,
        checklistItems: [
          {
            id: 5.1,
            isChecked: false,
            text: "Maxxia's representative |consultantName| has provided me on |proposalDate| with information and facts with respect to the motor vehicle lease proposal.",
          },
          {
            id: 5.2,
            isChecked: false,
            text: 'I acknowledge and agree that Maxxia does not provide financial, financial product, or taxation advice and has recommended that I obtain independent professional advice before deciding whether to proceed with salary packaging or Novated Leasing.',
          },
          {
            id: 5.3,
            isChecked: false,
            text: 'Maxxia has explained the purpose of this document and I have been provided with the opportunity to ask questions about my <i>Proposal</i> and the other documentation provided to me by Maxxia.',
          },
        ],
      },
    ],
  },
  {
    cardNumber: 3,
    cardHeadingNumber: 7,
    title: 'Your Salary Package Election',
    prefix:
      '<p>Details regarding your salary package election are shown below.</p>',
    prefixCard: {
      cardStyle: {
        borderWidth: 0,
        backgroundColor: '#f7f7f7',
        marginBottom: '12px',
      },
      cardBody: '',
      cardRowItems: [
        {
          title: 'Item Sacrificed',
          value: 'Novated Lease',
          boldVal: true,
          longVal: true,
        },
        {
          title: 'Purchase Price',
          value: '|purchasePrice|',
          isCurrency: true,
        },
        {
          title: 'Term of Deductions',
          value: '|term| months',
          boldVal: true,
        },
        {
          title: 'Monthly Amount of Deductions',
          value: '|monthlySalaryPackagingDeductions|',
          isCurrency: true,
        },
      ],
    },
    suffixCard: {
      cardStyle: { borderWidth: 0, backgroundColor: '#f7f7f7' },
      cardBody:
        '<b>Note:</b> In accordance with the provisions of the Financial Services Reform Act 2001, neither Rio Tinto nor its employees are authorised to provide any form of financial planning advice or information. Employees who wish to package their salary are encouraged to seek professional advice from a licensed financial planner.',
      cardRowItems: [],
    },
    pdfText:
      'You have already acknowledged the points below at the proposal stage.',
    datablocks: [
      {
        showIds: false,
        checklistItems: [
          {
            id: 6.1,
            isChecked: false,
            text: 'In making this election, I have not relied on any financial information or advice provided to me by Rio Tinto or any of its employees.',
          },
          {
            id: 6.2,
            isChecked: false,
            text: "I acknowledge Rio Tinto's recommendation that I seek independent financial advice.",
          },
          {
            id: 6.3,
            isChecked: false,
            text: 'I accept that this election alters my contract of employment and I authorise Rio Tinto to make deductions from my salary as set out in the Novated Lease Proposal I have established with Rio Tinto’s salary packaging provider.',
          },
          {
            id: 6.4,
            isChecked: false,
            text: 'I consent to the details of my remuneration and any salary sacrifice deductions I have made (and may subsequently make) being provided to my employer and to Rio Tinto’s nominated salary sacrificing provider.',
          },
        ],
      },
    ],
  },
  {
    cardNumber: 4,
    cardHeadingNumber: 8,
    title: 'Your Maxxia Authorisation',
    prefix: '<p>I have read and agree that:</p>',
    hideInPdf: true,
    datablocks: [
      {
        showIds: true,
        checklistItems: [
          {
            id: 1,
            isChecked: false,
            text: 'This is the lease I have discussed with my consultant, and I’m happy to proceed.',
          },
          {
            id: 2,
            isChecked: false,
            text: 'I acknowledge that the prices and rates specified above may be subject to change by the manufacturer or relevant authorities before delivery.',
          },
          {
            id: 3,
            isChecked: false,
            text: 'I acknowledge that Maxxia may receive commissions or rebates and retain interest earned on moneys held in connection with some services it provides or arranges to be provided by third Parties.',
          },
          {
            id: 4,
            isChecked: false,
            text: "I understand that the lease insurances are add-on, and that I won't be able to add them once my lease has begun. Before making a decision on these products I have read the <a style='color: #666; text-decoration: underline' href='https://www.maxxia.com.au/insurance/novated-lease#pds' target='_blank' rel='noopener noreferrer'>Product Disclosure Statements</a>.",
          },
        ],
      },
    ],
  },
]
